import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  lspDeliveryProcessFetchLspDeliveryProcess: null,
  lspDeliveryProcessFetchLspDeliveryProcessLoading: ['boolean'],
  lspDeliveryProcessFetchLspDeliveryProcessSuccess: ['process'],

  lspDeliveryProcessShowSyncSetting: null,
  lspDeliveryProcessShowSyncSettingLoading: ['boolean'],
  lspDeliveryProcessShowSyncSettingSuccess: ['syncSetting']
});

export const LspDeliveryProcessTypes = Types;
export default Creators;
